import React from "react";
import {
  Button,
  Link,
  FormControl,
  InputLabel,
  MenuItem,
  Slider,
  Switch,
  Modal,
  Box,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";

import TextField from "@mui/material/TextField";
import {
  validateEmail,
  validateFullName,
  validateMobileNumber,
  validatePincode,
} from "../../../../../Supporting files/HelpingFunction";
import DatePicker from "../../../../../Supporting files/DatePicker/DatePicker";
import SlidingPanel from "react-sliding-side-panel";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";

interface Props {
  attrName: any;
  open_status: boolean;
  value_update: Function;
}

const Personaldetails: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  //Profiel Variables
  const [fullName, setFullName] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [dob, setDob] = React.useState<Date | null>(null);
  const [maritalStatus, setMaritalStatus] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [pincode, setPincode] = React.useState("");
  const [city, setCity] = React.useState("");
  const [state, setState] = React.useState("");
  const [warnFullName, setWarnFullName] = React.useState(false);
  const [warnGender, setWarnGender] = React.useState(false);
  const [warnDob, setWarnDob] = React.useState(false);
  const [warnMaritalStatus, setWarnMaritalStatus] = React.useState(false);
  const [warnMobile, setWarnMobile] = React.useState(false);
  const [warnEmail, setWarnEmail] = React.useState(false);
  const [warnPincode, setWarnPincode] = React.useState(false);
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  //Add Member variables
  const [addMemberStatus, setAddMemberStatus] = React.useState(false);
  const [name, setName] = React.useState("");
  const [relationship, setRelationship] = React.useState("");
  const [age, setAge] = React.useState("");
  const [warnName, setWarnName] = React.useState(false);
  const [warnRelationship, setWarnRelationship] = React.useState(false);
  const [warnAge, setWarnAge] = React.useState(false);

  const [annualIncome, setAnnualIncome] = React.useState<
    number | string | Array<number | string>
  >(300000);

  let relationship_data = [
    { key: "Brother", value: "Brother" },
    { key: "Sister", value: "Sister" },
  ];
  let gender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];
  let maritalStatus_data = [
    { key: "Married", value: "Married" },
    { key: "Unmarried", value: "Unmarried" },
  ];
  let age_data = [
    { key: "20 Years", value: "20 Years" },
    { key: "22 Years", value: "22 Years" },
    { key: "24 Years", value: "24 Years" },
    { key: "26 Years", value: "26 Years" },
    { key: "28 Years", value: "28 Years" },
  ];

  const handleChange = (event: SelectChangeEvent, attrName: string) => {
    if (attrName === "gender") {
      setGender(event.target.value as string);
      setWarnGender(event.target.value.toString().length > 0 ? false : true);
    } else if (attrName === "maritalStatus") {
      setMaritalStatus(event.target.value as string);
      setWarnMaritalStatus(
        event.target.value.toString().length > 0 ? false : true
      );
    } else if (attrName === "relationship") {
      setRelationship(event.target.value as string);
      setWarnRelationship(
        event.target.value.toString().length > 0 ? false : true
      );
    } else if (attrName === "age") {
      setAge(event.target.value as string);
      setWarnAge(event.target.value.toString().length > 0 ? false : true);
    }
  };
  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    setAnnualIncome(newValue);
  };

  const [open, setOpen] = React.useState(false);

  function updateMasterState(attrName: any, value: any) {
    attrName(value);
  }

  const validatePersonalDetails = () => {
    let warn_full_name = !validateFullName(fullName);
    let warn_gender = gender.toString().length > 0 ? false : true;
    let warn_dob =
      dob == undefined ? true : dob.toString().length > 0 ? false : true;
    let warn_marital_status =
      maritalStatus.toString().length > 0 ? false : true;
    let warn_mobile = !validateMobileNumber(mobile);
    let warn_email = !validateEmail(email);
    let warn_pincode = !validatePincode(pincode);

    setWarnFullName(warn_full_name);
    setWarnGender(warn_gender);
    setWarnDob(warn_dob);
    setWarnMaritalStatus(warn_marital_status);
    setWarnMobile(warn_mobile);
    setWarnEmail(warn_email);
    setWarnPincode(warn_pincode);

    if (
      warn_full_name == false &&
      warn_gender == false &&
      warn_dob == false &&
      warn_marital_status == false &&
      warn_mobile == false &&
      warn_email == false &&
      warn_pincode == false
    ) {
    }
  };

  const validateAddMember = () => {
    let warn_name = name.toString().length > 0 ? false : true;
    let warn_relationship = relationship.toString().length > 0 ? false : true;
    let warn_age = age.toString().length > 0 ? false : true;

    setWarnName(warn_name);
    setWarnRelationship(warn_relationship);
    setWarnAge(warn_age);

    if (warn_name == false && warn_relationship == false && warn_age == false) {
    }
  };

  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 5) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };

  return (
    <Grid container spacing={0} className="profileSection">
      <SlidingPanel
        type={"right"}
        isOpen={addMemberStatus}
        size={75}
        panelClassName="slidingPanel"
        backdropClicked={() => setAddMemberStatus(false)}
      >
        <Box className={open_status == true ? "modalInner show" : "modalInner"}>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={9}>
              <h4 className="text-left mt-3">Add New Member</h4>
            </Grid>
            <Grid xs={3}>
              <Link
                className="close-button"
                onClick={() => {
                  setAddMemberStatus(false);
                }}
              />
            </Grid>
          </Grid>

          <div className="scrollable_area">
            <Grid container spacing={3} className="mt-1">
              <Grid xs={12}>
                <RKTextField
                  class_name="inputField"
                  title="Name"
                  value={name}
                  attrName={setName}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6} className="inputField">
                <SelectDropdown
                  class_name="inputField"
                  title="Relationship"
                  attrName={setRelationship}
                  value={relationship}
                  value_update={updateMasterState}
                  dropdown_data={relationship_data}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6} className="inputField">
                <SelectDropdown
                  class_name="inputField"
                  title="Age"
                  attrName={setAge}
                  value={age}
                  value_update={updateMasterState}
                  dropdown_data={age_data}
                  warn_status={false}
                />
              </Grid>
            </Grid>
          </div>

          <Grid container spacing={2}>
            <Grid
              xs={12}
              style={{ textAlign: "center", position: "relative" }}
              className="ctaBtn"
            >
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {}}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
      </SlidingPanel>
      {/* <-------------------------Add new member Pop up End------------------------------> */}
      <Grid xs={8}>
        <Grid container alignItems="center" spacing={2}>
          <Grid xs={6}>
            <h3 className="mb-0">Profile</h3>
          </Grid>
          <Grid xs={6} className="text-right">
            <Link
              className="greenBtn addfile"
              underline="none"
              onClick={() => {
                setAddMemberStatus(true);
              }}
            >
              Add Member
            </Link>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid xs={12}>
            <div className="profilePicture">
              <span className="profileIcon">
                <img src="./images/profile_vector_icon.svg" alt="profile" />
              </span>
              <span className="profileName">
                <h6>Rahul Raghuvanshi</h6>
                <Link underline="none">Change Picture</Link>
              </span>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid xs={6}>
            <RKTextField
              class_name="inputField"
              title="Full Name"
              value={fullName}
              attrName={setFullName}
              value_update={updateMasterState}
              warn_status={false}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid xs={4} className="inputField mb-5">
            <SelectDropdown
              class_name="inputField"
              title="Gender"
              value={gender}
              attrName={setGender}
              value_update={updateMasterState}
              dropdown_data={gender_data}
              warn_status={false}
            />
          </Grid>
          <Grid xs={4}>
            <DatePicker
              class_name="inputField"
              title="DOB"
              value={dob}
              attrName={setDob}
              value_update={updateMasterState}
              error_message="Please enter DOB"
              warn_status={false}
            />
          </Grid>
          <Grid xs={4}>
            <SelectDropdown
              class_name="inputField"
              title="Marital Status"
              value={maritalStatus}
              attrName={setMaritalStatus}
              value_update={updateMasterState}
              dropdown_data={maritalStatus_data}
              warn_status={false}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid xs={6}>
            <RKTextField
              class_name="inputField"
              title="Mobile"
              value={mobile}
              attrName={setMobile}
              value_update={updateMasterState}
              warn_status={false}
            />
          </Grid>
          <Grid xs={6}>
            <RKTextField
              class_name="inputField"
              title="Email"
              value={email}
              attrName={setEmail}
              value_update={updateMasterState}
              warn_status={false}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} alignItems="center">
          <Grid md={4} lg={3}>
            <RKTextField
              class_name="inputField"
              title="Pincode"
              value={pincode}
              attrName={setPincode}
              value_update={updateMasterState}
              warn_status={false}
            />
          </Grid>
          <Grid md={6} className="mb-5">
            <p>
              {city}, {state}
            </p>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid xs={12}>
            <h6 className="fontMontserrat font-bold">Annual Income</h6>
          </Grid>
          <Grid xs={12} className="annualIncomeValue inputField">
            <div className="amountRange">
              <span className="inr">0</span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span className="inr">10,00,000</span>
            </div>
            <Slider
              className="incomeSlider"
              value={typeof annualIncome === "number" ? annualIncome : 0}
              onChange={handleSliderChange}
              aria-labelledby="input-slider"
              min={0}
              max={10000000}
            />
            <TextField
              value={annualIncome.toLocaleString("en-US")}
              className="rupeeIcon"
              id="outlined-basic"
              variant="outlined"
            />

            <p className="amountinWords">
              Ten lakh ninty thousand five hundred
            </p>
          </Grid>

          <Grid xs={12} className="ctaBtn mb-5">
            <Button
              className="submitBtn"
              onClick={() => validatePersonalDetails()}
            >
              Save Changes
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid xs={4}>
        <Grid container spacing={0} className="otherDetails">
          <Grid xs={12}>
            <h5 className="mb-0">Other Details</h5>
          </Grid>

          <Grid xs={12} className="switchDetails">
            <p>My parents are dependent</p>
            <input type="checkbox" className="switch" />
          </Grid>

          <Grid xs={12} className="switchDetails">
            <p>I have a bike</p>
            <input type="checkbox" className="switch" />
          </Grid>

          <Grid xs={12} className="switchDetails">
            <p>I have a Car</p>
            <input type="checkbox" className="switch" />
          </Grid>

          <Grid xs={12} className="switchDetails">
            <p>I have a house</p>
            <input type="checkbox" className="switch" />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Personaldetails;
